<template>
    <div class="loading" :class="{'loadingDark':isDark}">
        <div class="loadingBox">
            <img src="../../assets/img/common/loadingIcon.png" alt="">
            <span>加载中</span>
        </div>
    </div>
</template>

<script>
export default {
    name: "Loading",
    computed: {
        isDark () {
            return this.$store.state.common.isDark
        }
    }
}
</script>

<style scoped lang="less">
    .loading {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background-color: #fff;
        z-index: 10000;
        .loadingBox {
            margin-top: 35px;
            text-align: center;
            img {
                width: 16px;
                display: inline-block;
                vertical-align: middle;
                animation: img .8s linear infinite;
            }
            span{
                font-size: 13px;
                color: #666;
                margin-left: 6px;
            }
            @keyframes img{
                0%{transform:rotate(0deg);}
                25%{transform:rotate(90deg);}
                50%{transform:rotate(180deg);}
                75%{transform:rotate(270deg);}
                100%{transform:rotate(360deg);}
            }
        }
    }
    .loadingDark{
        background-color: #121212;
        .loadingBox span{
            color: #a9a9a9;
        }
    }
</style>
